module.exports = __webpack_public_path__ + "img/car-battery-solid.452866c0.svg";